module.exports = ".limit-galleries-info p {\n  color: #ea1e21; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/integrations/connect-galleries/modals/select-existing-gallery-modal/select-existing-gallery.modal.scss
// module id = ./web/modern/components/integrations/connect-galleries/modals/select-existing-gallery-modal/select-existing-gallery.modal.scss
// module chunks = 0